import { BaseItem } from './common';
import { BaseDocument } from './document';

enum Publisher {
  Documo = 'DOCUMO',
}

interface BaseFax {
  from: string;
  to: string;
  publisher: Publisher;
  publisherReferenceId: string | null;
  success: boolean | null;
  failureReason: string | null;
}

export interface Fax extends BaseItem, BaseFax {
  documents: FaxDocument[];
}

interface BaseFaxDocument extends BaseDocument {
  faxId: string;
  encounterId: string;
  documentId: string;
}

interface FaxDocument extends BaseItem, BaseFaxDocument {}
